(() => {
  /**
   * Redirects the user back if they don't have permission
   * Falls back to homepage if referrer is invalid or empty
   */
  const hasPermission = false
  const fallbackUrl = "/"

  if (!hasPermission) {
    const ref = document.referrer
    const sameOrigin = ref && new URL(ref).origin === window.location.origin

    if (sameOrigin) {
      window.location.href = ref
    } else {
      window.location.href = fallbackUrl
    }
  }
})()